import { API_BASE_URL } from "@/config";

export function fetchCustomerData({ customer_id, customer_application, token }) {
  return new Promise((resolve, reject) => {
    if (!API_BASE_URL) {
      reject("Server configuration error. Please try again later.");
      return;
    }

    const url = `${API_BASE_URL}/verify_api/workflow_management_api/view_customer_data/${customer_id}/${customer_application}/`;

    $.ajax({
      method: "GET",
      url,
      contentType: "application/json",
      headers: { Authorization: `Token ${token}` },
      success: (response) => {
        const data = response.data || {};
        const documents = response.documents || [];
        const audit_trails = response.audit_trails || [];

        resolve({
          id_number: response.id_number,
          first_name: data.first_name,
          last_name: data.last_name,
          email: data.email,
          reference: data.reference,
          phone_number: data.phone_number,
          date_joined: data.date_joined,
          audit_trails: audit_trails,
          documents: documents,
        });
      },
      error: (error) => {
        reject(error);
      },
    });
  });
}